import { useEffect } from "react";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { FlightsErrorReporter } from "../utils/report-error.js";
export default function useEventsTest() {
    useEffect(() => {
        if (!isFeatureRunningClientSide("FLIGHTS_FE_PERIODIC_WARNING_TEST")) {
            return;
        }
        const ts = Date.now();
        FlightsErrorReporter.getInstance().sendError(new Error(`events test js_error ts=${ts}`));
    }, []);
}
